// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BD30j","top":"styles_top__3Hdq0","left":"styles_left__3gLcJ","description":"styles_description__1N4dX"};